export default {
  roadmapManualMetadata: {
    titles: {
      create: 'Создание ИПР',
      document: 'Индивидуальный план развития',
      tasks: 'Задачи плана развития',
      decisions: 'Решения по плану',
      commonTasks: 'Общие задачи',
      skillTasks: 'Задачи по компетенциям',
      employeeRequest: 'Запрос сотрудника',
      returnRoadmap: 'Причины возврата ИПР',
    },
    descriptions: {
      create:
        'Выберите, для какого количества сотрудников создаёте ИПР, и заполните все обязательные поля формы.',
      noSupervisor: 'Руководитель не назначен — выберите наставника',
      selectedTasks: 'Выбрано задач: {count}',
    },
    buttons: {
      propose: 'Предложить ИПР',
      create: 'Создать ИПР',
      open: 'Открыть ИПР',
      board: 'Перейти на доску задач',
      tasksStat: 'Посмотреть статистику задач',
      cancel: 'Отменить ИПР',
      delete: 'Удалить черновик',
      start: 'Направить в работу',
      sendApproval: 'Отправить на согласование',
      approve: 'Согласовать',
      returnRevision: 'Вернуть на доработку',
      sendAcceptance: 'Отправить на подтверждение выполнения',
      accept: 'Подтвердить выполнение',
      returnWork: 'Вернуть в работу',
      startWork: 'Направить в работу',
      submitForApproval: 'Отправить на согласование',
      submitForAcceptance: 'Отправить на подтверждение выполнения',
      cancelPlan: 'Отменить ИПР',
      addTask: 'Добавить задачу',
      hideFromBoard: 'Скрыть с доски',
      removeTask: 'Удалить задачу',
      addMoreTask: 'Добавить ещё задачу',
    },
    formLabels: {
      team: 'Команда / подразделение',
      teamGroup: 'Подразделение',
      goalType: 'Тип цели развития',
      reason: 'Основание создания',
      target: 'Цель ИПР',
      skillType: 'Тип навыков',
      approver: 'Согласующий',
      source: 'Источник ИПР',
      needApproval: 'Требуется согласование руководителя',
      singleMode: 'Для одного сотрудника',
      groupMode: 'Для группы сотрудников',
      materialType: 'Тип материала',
      competency: 'Компетенция',
      taskName: 'Название задачи',
    },
    detailsLabels: {
      why: 'Почему хочет создать ИПР',
      subject: 'Что хочет развить',
      result: 'Какой результат хочет получить',
    },
    tableHeaders: {
      decision: 'Решение',
      date: 'Дата и время',
    },
    sources: {
      manual: 'Создан вручную',
      selfTest: 'Из самооценки',
      test360: 'Из оценки 360°',
    },
    roles: {
      mentor: 'Наставник',
      approver: 'Согласующий',
      both: 'Наставник, Согласующий',
    },
    stubs: {
      noTasks: 'В плане пока нет задач',
      filtered: 'По выбранным фильтрам ничего не найдено',
    },
    // messages
    successMessages: {
      addToBoard: 'Задачи добавлены на доску',
      hideFromBoard: 'Задачи скрыты с доски',
      deleteTasks: 'Задачи удалены',
      action: 'Статус ИПР изменён',
    },
    errorMessages: {
      maxEmployees: 'Можно выбрать не более {count} сотрудников',
      createTasks: 'Не удалось добавить задачи',
      changeBoardTasks: 'Не удалось изменить отображение задач на доске',
      deleteSelectedTasks: 'Не удалось удалить выбранные задачи',
      save: 'Не удалось сохранить ИПР',
      returnRoadmap: 'Не удалось вернуть ИПР',
      load: 'Не удалось загрузить ИПР',
      options: 'Не удалось загрузить данные для редактирования',
      action: 'Не удалось выполнить действие',
      deleteTask: 'Не удалось удалить задачу',
    },
    // confirm dialogs
    confirmDeleteTask: {
      title: 'Удалить задачу?',
      text: 'Задача будет удалена безвозвратно.',
    },
    confirmDeleteSelectedTasks: {
      title: 'Удалить выбранные задачи?',
      text: 'Выбранные задачи будут удалены безвозвратно.',
    },
    confirmSpecChange: {
      title: 'Подтверждение смены специализации',
      automaticOnly:
        'Список задач будет собран заново под выбранную специализацию. Текущие задачи плана будут заменены.',
      withManual:
        'Список задач будет собран заново под выбранную специализацию. Задачи, добавленные вручную, сохранятся, но потеряют привязку к компетенции.',
    },
    confirmDiscardChanges: {
      title: 'Отменить внесённые изменения?',
      text: 'Все несохранённые изменения будут потеряны.',
      button: 'Да, отменить изменения',
    },
    confirmCancelRoadmap: {
      title: 'Отменить ИПР?',
      text: 'План перейдёт в статус «Отменён». Обратного перехода из статуса «Отменён» нет — возобновить план нельзя, нужно создавать новый.',
      button: 'Да, отменить',
      buttonCancel: 'Не отменять',
    },
    confirmDeleteRoadmap: {
      title: 'Удалить черновик ИПР?',
      text: 'Черновик будет удалён без возможности восстановления.',
    },
  },
  roadmapMetadata: {
    changeMentorTitle: 'Назначить наставника',
    createMaterialTitle: 'Новый материал',
    changeMaterialTitle: 'Редактировать материал',
    formLabels: {
      name: 'Название материала',
      skillId: 'Компетенция',
      deadline: 'Дедлайн',
      typeId: 'Тип материала',
      importance: 'Важность',
    },
    statuses: {
      all: 'Все',
      new: 'Новая',
      inProgress: 'В работе',
      done: 'Готово',
    },
    addMaterialFieldsButton: 'Добавить материал',
    removeMaterialFieldsButton: 'Удалить материал',
    moveMaterialsButton: {
      top: 'Переместить в прочие навыки для развития',
      general: 'Переместить в очевидные зоны роста',
    },
    headers: {
      name: 'Материал',
      type: 'Тип материала',
      importance: 'Важность',
      deadline: 'Дедлайн',
      status: 'Статус',
    },
    tooltips: {
      manualMaterial: 'Материал добавлен в плане развития',
      manualTask: 'Задача добавлена в плане развития',
      showMaterial: 'Материал добавлен на доску',
      showTask: 'Задача добавлена на доску',
      supervisorButton: 'Зачем обновлять и фиксировать план развития',
      employeeButton: 'Зачем обновлять план развития',
      employee:
        'Обновите план развития, чтобы получить наиболее актуальные результаты на основе последних оценок. Обратите внимание, что текущий прогресс будет сброшен, не будут удалены только задачи которые были добавлены в план вручную.',
      supervisor:
        'Обновите план развития, чтобы получить наиболее актуальные результаты на основе последних оценок. Обратите внимание, что текущий прогресс будет сброшен, не будут удалены только задачи которые были добавлены в план вручную. После фиксации плана, кнопка «Обновить план» станет недоступной, но вы сможете добавлять, удалять и перемещать задачи между блоками.',
      button: 'Зачем обновлять и фиксировать план развития',
      text: 'Обновите план развития, чтобы получить наиболее актуальные результаты на основе последних оценок. Обратите внимание, что текущий прогресс будет сброшен, не будут удалены только задачи которые были добавлены в план в ручную. После фиксации плана, кнопка «Обновить план» станет недоступной. Внесение изменений в план также станет невозможным.',
    },
    selectDateButton: 'Выбрать дату',
    selectImportanceButton: 'Выбрать важность',
    devPlanTitle: 'План развития компетенций',
    recreateRoadmapButton: 'Обновить план',
    fixateRoadmapButton: 'Зафиксировать изменения',
    requiredTarget: 'Поля «Описание цели» и «Дедлайн» - обязательные',
    commonMaterialsTitle: 'Общие материалы и задачи для развития',
    blocksMaterialsTitle: 'Материалы и задачи по результатам оценки',
    topSectionTitle: 'Очевидные зоны роста',
    generalSectionTitle: 'Прочие материалы и задачи для развития',
    progressDescription: 'Общий прогресс выполнения плана развития',
    lowSkills: 'Компетенции, по которым у пользователя самые низкие оценки',
    // messages
    successMessages: {
      changeMentor: 'Наставник успешно изменён',
      saveTarget: 'Цель успешно сохранена',
      createMaterial: 'Материал успешно создан',
      changeMaterial: 'Материал успешно изменён',
      showMaterials: 'Материалы успешно добавлены на доску',
      moveMaterials: 'Материалы успешно перемещены',
      deleteMaterials: 'Материалы успешно удалены',
      changeTask: 'Задача успешно изменёна',
      recreateRoadmap: 'План развития успешно обновлён',
      fixateRoadmap: 'План развития успешно зафиксирован',
    },
    errorMessages: {
      changeMentor: 'Не удалось изменить наставника',
      saveTarget: 'Не удалось сохранить цель',
      createMaterial: 'Не удалось создать материал',
      changeMaterial: 'Не удалось изменить материал',
      showMaterials: 'Не удалось добавить материалы на доску',
      moveMaterials: 'Не удалось переместить материалы',
      deleteMaterials: 'Не удалось удалить материалы',
      changeTask: 'Не удалось изменить задачу',
      recreateRoadmap: 'Не удалось обновить план развития',
      fixateRoadmap: 'Не удалось зафиксировать план развития',
      targetRoadmap: 'Необходимо заполнить «Цель», чтобы зафиксировать план развития',
    },
    // confirm dialogs
    confirmShowMaterials: {
      title: 'Добавить материалы на доску?',
      button: 'Да, добавить',
    },
    confirmMoveMaterials: {
      title: 'Переместить материалы?',
      button: 'Да, переместить',
    },
    confirmDeleteMaterials: {
      title: 'Удалить материалы?',
      text: 'Отменить данное действие будет невозможно',
    },
    confirmRecreateRoadmap: {
      title: 'Обновить план?',
      text: 'План будет сформирован заново и изменения будут утеряны.',
      button: 'Да, обновить',
    },
    confirmFixateRoadmap: {
      title: 'Зафиксировать план?',
      text: 'Внесение изменений в состав плана станет недоступно.',
      button: 'Да, зафиксировать',
    },
    //
  },
};
